<template>
    <div class="col-md-12 col-lg-12 col-xl-9">
        <div class="sport-menu-tabs-sec">
            <WalletHeader/>
            <section class="Bank-transfer-wrapper walletPage-wrap">
                <div class="container">
                    <div class="withdraw-sec">
                        <div class="input-field">
                            <label class="form-label">{{ $t('deposit-amount','Deposit Amount')}}</label>
                            <input class="form-control" type="tel" v-model="amount" placeholder="Enter deposit amount" @input="amount = $helper.sanitizeNumber(+amount, +walletData?.deposit_range?.max || 99999999)">
                            <div class="min-max-section">
                                <div class="min-max-con">
                                    <h6>{{$t('min', 'min')}} <span>{{ walletData?.deposit_range?.min ? walletData?.deposit_range?.min : 100 }}</span></h6>
                                </div>
                                <div class="min-max-icon">
                                    <img src="@/assets/images/min-max-icon.svg" alt="max" loading="lazy">
                                </div>
                                <div class="min-max-con">
                                    <h6>{{$t('max', 'max')}} <span>{{ walletData?.deposit_range?.max ? walletData?.deposit_range?.max : 100000}}</span></h6>
                                </div>
                            </div>
                        </div>
                        <div class="thm-gradient-but deposit-amount-bx deposit-amount-btn">
                            <div class="first-row-box data_list_val" v-if="walletData">
                                <template  v-for="(stake, index) in (userTransactionStakes ? [...userTransactionStakes] : walletData?.stake_button)" :key="index">                                 
                                    <div class="small-box shortNum">
                                        <button class="btn" @click="setAmount(stake)">{{ stake }}</button>
                                    </div>
                                </template>
                            </div>
                        </div>
                        <div class="withdraw-btn d-flex gap-2">
                            <a :class="{'btn-disabled' : !$auth.status}" href="#editModal" data-bs-toggle="modal" class="btnTheme-yellow w-50">
                                <span><img loading="lazy" src="@/assets/images/edit-icon.svg" alt="edit-icon"></span>
                                <span>{{$t('edit-stake', 'Edit Stake')}}</span>
                            </a>
                            <a :class="{'btn-disabled' : !$auth.status || amount < walletConfig?.deposit_range?.min }" @click="callForDepositMethods()" class="btnTheme-yellow w-50">
                                <span>{{$t('submit', 'Submit')}}</span>
                            </a>
                        </div>
                    </div>
                    <div class="mt-3">
                        <TutorialVideo type = "2" v-if="Object.values(walletConfig?.deposit_video).some(val => val?.trim() !== '')"/>
                    </div>
                </div>
            </section>
        </div>
        <Support></Support>
    </div>
    <EditStakeModal @updateStakes="saveButtonClick" v-if="walletData" :stakes="walletData"></EditStakeModal>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import TutorialVideo from '../components/TutorialVideo.vue';
import WalletHeader from '../components/WalletHeader.vue';
import Support from '@/shared/components/support/Support.vue';
import EditStakeModal from '../components/EditStakeModal.vue';
export default {
    name: 'WalletDeposit',
    inject: ['walletConfig'],
    components: {
        EditStakeModal,
        Support,
        WalletHeader,
        TutorialVideo,

    },
    data(){
        return{
            walletData: [],
            amount: null,
        }
    },
    computed: {
        minAmount() {
            return this.walletData?.range?.minimum_deposit ?? 100;
        },
        maxAmount() {
            return this.walletData?.range?.maximum_deposit ?? 99999999;
        }
    },
    mounted() {
        if(this.$auth.user.isDemo){
            this.$errorToast("Wallet access is restricted for demo user");
            setTimeout(() => {
                this.$router.push({name: 'Home'})
            }, 500);
        }
        // if (this.$route.query.walletData) {
        //     this.walletData = JSON.parse(this.$route.query.walletData)
        // } else {
        //     this.getWalletLimitsServiceCall();
        // }
    },
    created() {
        this.getWalletLimitsServiceCall();
    },
    methods: {
        setAmount(val){
            if(val > this.walletConfig?.range?.maximum_deposit){
                val = this.walletConfig?.range?.maximum_deposit;
            }
            this.amount += parseInt(val);
            if(this.amount > this.$helper.sanitizeNumber(+this.amount, +this.walletData?.deposit_range?.max || 99999999)){
             this.amount = this.$helper.sanitizeNumber(+this.amount, +this.walletData?.deposit_range?.max || 99999999)
            }
        },
        getWalletLimitsServiceCall() {

            
            this.walletData = this.walletConfig;
            if(!this.walletData) {
                this.initializeStake();
            }  
        },
        initializeStake(){
                this.walletData.stake_button = {
                 0: '100',
                 1: '500',
                 2: '1000',
                 3: '2000'
                };
        },
        callForDepositMethods() {
            if (this.amount == null || 
            this.amount < (!this.walletConfig?.deposit_range?.min ? 100 : this.walletConfig?.deposit_range?.min) || 
            this.amount > (!this.walletConfig?.deposit_range?.max ? 99999999 : this.walletConfig?.deposit_range?.max)) {
                const minAmount = !this.walletConfig?.deposit_range?.min ? 100 : this.walletConfig?.deposit_range?.min;
                const maxAmount = !this.walletConfig?.deposit_range?.max ? 99999999 : this.walletConfig?.deposit_range?.max;
                this.$errorToast(`${this.$t('please-enter-an-amount-between', 'Please enter an amount between')} ${minAmount} and ${maxAmount}.`);
            } else {
                console.log("ooo");
                
                this.goToDepositMethods();
            }
        },
        goToDepositMethods() {
            this.$store.dispatch('setDepositAmount', this.amount);
            this.$router.push({ name: 'deposit-payment-method' }) 
        },
        saveButtonClick(stakes) {
            this.walletData.stake_button =  stakes;
        },
    }

}
</script>

<style></style>